import { useQuery } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Historial de auditoria de un ticket (GET /tickets/:id/historial).
const useTicketHistorial = (headquarter, id) =>
  useQuery({
    queryKey: ticketsKeys.historial(headquarter, id),
    queryFn: async () => {
      const data = await ticketsService.obtenerHistorial({ headquarter, id });
      return Array.isArray(data) ? data : [];
    },
    enabled: Boolean(headquarter && id),
  });

export default useTicketHistorial;
